"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventContractV3 = exports.BaseEventDataContract = exports.EventTypesV3 = void 0;
const class_validator_1 = require("class-validator");
const base_1 = require("../../../base");
const class_transformer_1 = require("class-transformer");
var EventTypesV3;
(function (EventTypesV3) {
    EventTypesV3["CUSTOMER_EVENTS"] = "customer_events";
})(EventTypesV3 || (exports.EventTypesV3 = EventTypesV3 = {}));
class BaseEventDataContract {
}
exports.BaseEventDataContract = BaseEventDataContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseEventDataContract.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], BaseEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], BaseEventDataContract.prototype, "version", void 0);
class EventContractV3 {
    constructor(params) {
        this.data = base_1.GreenlineEvent.create(BaseEventDataContract, params);
    }
}
exports.EventContractV3 = EventContractV3;
//# sourceMappingURL=EventContract.js.map